import React from "react";
import { TableCompData } from "../../../components";
import EmptyTable from "../../../components/Common/EmptyTable";
import {
  SettingCompanyPrefixHeader,
  ViewStaffData,
} from "../../../utils/TableHeader";
import { Spinner } from "react-bootstrap";

export default function AllTables({
  TableDropDown,
  onSubmit,
  tableHeader,
  tableData=[],
  emptyMessage,
  btnText,
  marginBottom,
  cellPadding = "10px",
  isLoading=false
}) {
  return (
    <div>
      <div className="mb-5 relative">
       {isLoading&& <div className="flex justify-center items-center top-5 z-10 absolute left-0 right-0">
          <Spinner/>
        </div>}
        <div className={`${isLoading &&'opacity-30' }`}>
        <TableCompData
          cellPadding={cellPadding}
          columns={
            tableHeader
              ? tableHeader
              : SettingCompanyPrefixHeader(TableDropDown)
          }
          data={tableData ? tableData : ViewStaffData}
          marginBottom={marginBottom}
          message={(!isLoading&&tableData?.length===0) &&
            <EmptyTable
              Message={emptyMessage || "No prefix has been created"}
              btnText={btnText || "Create new"}
              onClick={onSubmit}
            />
          }
        />
        </div>
      </div>
    </div>
  );
}
